import React from "react"
import {useIntl} from "react-intl";
import {showDeleteConfirm} from "../../../../../platform/hocs/Form";
import {MultiAccountView} from "./MultiAccountView";
import {MultiAccountViewArea} from "./MultiAccountViewArea";
import {setCurrentAccount} from "../../../../../../services/accountService";

export interface MultiAccountProps {
  platformAccounts: any;
  user: any;
  hasTwoAccount?: any;
  areaCandidate?: boolean
  performa?: boolean
}

export const MultiAccount = (props: MultiAccountProps) => {
  const {
    hasTwoAccount,
    platformAccounts,
    user,
    areaCandidate = false,
    performa = true
  } = props
  const intl = useIntl()

  const handleAccountsChange = async (id: number) => {
    setCurrentAccount(id)
    document.location.reload();
  }

  return (
    <div>
      {hasTwoAccount && platformAccounts
        .filter((account: any) => account.id !== user.id )
        .map((account: any) => {
          const {fullName, email, imageUrl, id } = account
          return (
            <div key={fullName}>
              {areaCandidate &&
                <MultiAccountViewArea
                  name={fullName}
                  email={email}
                  src={imageUrl}
                  onClick={() => {
                    showDeleteConfirm(
                      intl.formatMessage({id: 'user.change_account'}),
                      () => handleAccountsChange(id)
                    )
                  }}
                />
              }
              {performa &&
                <MultiAccountView
                  name={fullName}
                  email={email}
                  src={imageUrl}
                  onClick={() => {
                    showDeleteConfirm(
                      intl.formatMessage({id: 'user.change_account'}),
                      () => handleAccountsChange(id)
                    )
                  }}
                />
              }
            </div>
          )
      })}
    </div>
  )
}
